package br.com.vvrefeicoes.portal.domain.model

data class CompanyRef(
    val id: Int,
    val name: String,
)
